module.exports = __webpack_public_path__ + "static/Parastate-19a912d44d61ead293f547fa46bc7ec0.png";